import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { COLORS } from 'styleguide';
import { lighten } from 'polished';

const ChatRoomButton = styled.button`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 15px 15px 25px 15px;
  border: 0;
  border-bottom: 1px solid ${({ isOpen }) => (isOpen ? 'transparent' : COLORS.line)};
  background-color: ${({ active }) => (active ? COLORS.primary : COLORS.black)};
  cursor: pointer;

  &:hover {
    background-color: ${({ active }) => (active ? COLORS.primary : lighten(0.01, COLORS.black))};
  }

  &:focus {
    outline: none;
    background-color: ${({ active }) => (active ? lighten(0.03, COLORS.primary) : lighten(0.03, COLORS.black))};
  }

  &:last-child {
    border-bottom: 0;
  }
`;

ChatRoomButton.propTypes = {
  active: PropTypes.bool,
  isOpen: PropTypes.bool,
};

ChatRoomButton.defaultProps = {
  isOpen: false,
  active: false,
};

export default ChatRoomButton;
